import { AppTheme, SxProps } from '@cp/ds';
import { VacancyCardTokens } from 'src/entities/vacancy';

export interface VacancyCardAppearanceOptions {
  highlighted: boolean;
  viewed: boolean;
  replied: boolean;
}

export const getVacancyCardAppearanceSx = (
  theme: AppTheme,
  { highlighted, viewed, replied }: VacancyCardAppearanceOptions,
): SxProps => {
  const pinkBackground = theme.palette['pink ultra light'];
  const textColor = replied
    ? VacancyCardTokens.repliedColor(theme.palette.gray)
    : viewed
      ? VacancyCardTokens.viewedColor(theme.palette.gray)
      : undefined;

  return {
    [VacancyCardTokens.backgroundColor]: highlighted ? pinkBackground : theme.palette.background.default,
    ...(highlighted && { [VacancyCardTokens.borderColor]: theme.palette['brand pink'] }),
    ...(textColor && { [VacancyCardTokens.textColor]: textColor }),
    ...(highlighted && {
      '@media (pointer: fine)': {
        '&&:hover': {
          backgroundColor: pinkBackground,
          '& [data-card-description=gradient]': {
            background: `linear-gradient(to right, transparent, ${pinkBackground})`,
          },
          '& [data-card-description=linear]': {
            backgroundColor: pinkBackground,
          },
        },
      },
    }),
  };
};
